import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogArchiveOrUnarchiveUserComponent } from './dialog-archive-or-unarchive-user.component';


@NgModule({
  entryComponents: [
    DialogArchiveOrUnarchiveUserComponent
  ],
  declarations: [
    DialogArchiveOrUnarchiveUserComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    DialogArchiveOrUnarchiveUserComponent
  ]
})
export class DialogArchiveOrUnarchiveUserModule { }
